"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TextProperties2 = _interopRequireDefault(require("./TextProperties"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TextRenderProperties = /*#__PURE__*/function (_TextProperties) {
  (0, _inherits2["default"])(TextRenderProperties, _TextProperties);

  var _super = _createSuper(TextRenderProperties);

  function TextRenderProperties(textProperties, textLines, textWidth, textHeight) {
    var _this;

    (0, _classCallCheck2["default"])(this, TextRenderProperties);
    _this = _super.call(this, textProperties);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textLines", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textWidth", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textHeight", 0);
    _this._textLines = textLines;
    _this._textWidth = textWidth;
    _this._textHeight = textHeight;
    return _this;
  }

  (0, _createClass2["default"])(TextRenderProperties, [{
    key: "textLines",
    get: function get() {
      return this._textLines;
    }
  }, {
    key: "textWidth",
    get: function get() {
      return this._textWidth;
    }
  }, {
    key: "textHeight",
    get: function get() {
      return this._textHeight;
    }
  }]);
  return TextRenderProperties;
}(_TextProperties2["default"]);

exports["default"] = TextRenderProperties;